import { post } from '../utility';

/**
 * One call returns everything the dashboard renders, with every good/warning/error already
 * decided on the backend. See libs/monitoring/processHealth.js.
 */
export const getProcessHealth = ({ callback }) => {
	post({
		method: 'processHealth.get',
		params: {},
		callback,
	});
};
